import React from 'react'

interface DownArrowIconProps {
  fillColor?: string
  width?: string
  className?:string
}

const DownArrowIcon: React.FC<DownArrowIconProps> = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width= {props.width ?? '100%'} viewBox='0 0 15 10' className={props.className ?? 'DownIcon'}>
    <defs />
    <path
      fill='#008BD2'
      fillRule='evenodd'
      d='M14.344 2.47l-6.96 7.145L.425 2.47c-.464-.478-.464-1.251 0-1.727.465-.478 1.218-.477 1.682 0L7.385 6.16 12.663.742c.465-.477 1.217-.477 1.682 0 .463.477.463 1.25-.001 1.727z'
    />
  </svg>
)

export default DownArrowIcon
